import React, { ReactElement, useState } from 'react';
import { Button } from 'components/common/Button';
import { makeFormFieldState, FormField, Validators, validateForm } from 'components/common/form-utils/form';
import LoadingModal from 'components/common/modals/LoadingModal';
import Banner from 'components/common/Banner';
import { getRandomLoadingTime, progressLoadingBar } from 'utils/loading-bar-progress';

const ContactPage = (): ReactElement => {
  const [isSuccessfulSubmission, setIsSuccessfulSubmission] = useState(false);
  const [formIsValid, setFormIsValid] = useState(true);
  const [submitLoadingModalOpen, setSubmitLoadingModalOpen] = useState(false);
  const [submissionProgress, setSubmissionProgress] = useState(0);
  const form = makeFormFieldState({
    forename: { visibleName: 'Forename', required: true },
    surname: { visibleName: 'Surname' },
    email: { visibleName: 'Email', required: true, validations: [Validators.isEmail()] },
    telephone: {
      visibleName: 'Telephone', validations: [
        Validators.hasLength(10, { excludeWhitespace: true }), Validators.isNumeric({ allowWhitespace: true })],
    },
    message: { visibleName: 'Message', required: true },
  });

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    const validForm = validateForm(form);
    setFormIsValid(validForm);
    if (!validForm) return;

    setSubmitLoadingModalOpen(true);
    await progressLoadingBar({
      loadingTime: getRandomLoadingTime({ min: 10000, max: 30000 }),
      onUpdate: ({ percentage }) => setSubmissionProgress(percentage),
    });
    setSubmitLoadingModalOpen(false);
    setSubmissionProgress(0);
    setIsSuccessfulSubmission(true);
  };
  return (<React.Fragment>
    <div className='m-auto w-3/5'>
      {isSuccessfulSubmission ? (
        <div>
          <div className="text-md m-6 mb-8 hover:text-secondary" id="success-message">
            Thanks {form.forename.value}, we appreciate your feedback.
          </div>
          <Button grey id='back-button' linkTo='/'>Back</Button>
        </div>
      ) : (<form onSubmit={onSubmit}>
        {formIsValid ? (
          <Banner><div><strong>We welcome your feedback - </strong>tell it how it is.</div></Banner>)
          : (<Banner><div><strong>We welcome your feedback - </strong>
            but we wont get it unless you complete the form correctly.</div></Banner>)}
        <div className='flex flex-col pt-4 place-items-start'>
          <FormField field={form.forename} validateOnChange />
          <FormField field={form.surname} validateOnChange />
          <FormField field={form.email} validateOnChange />
          <span className="mt-4 mx-2 text-sm">Your email address will only be used in reply to this
            message.</span>
          <span className="mb-4 mx-2 text-sm">We <strong>never</strong> send spam email or give your email
            address to
            others.</span>
          <FormField field={form.telephone} validateOnChange />
          <span className="my-4 mx-2 text-sm">
            Only provide your telephone number if you want us to contact you this way.
          </span>
          <FormField textarea field={form.message} validateOnChange />
          <div className='w-full grid place-items-end'>
            <span className='p-2'>
              <Button primary id='submit-button' type='submit'>Submit</Button>
            </span>
          </div>
        </div>
      </form>)}
    </div>
    <LoadingModal
      isOpen={submitLoadingModalOpen}
      heading='Sending Feedback'
      progress={submissionProgress}
    />
  </React.Fragment>);
};
export default ContactPage;
